import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7366953b"
import script from "./requestGroup.js?vue&type=script&lang=js&external"
export * from "./requestGroup.js?vue&type=script&lang=js&external"
import style0 from "./requestGroup.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports